"use client";

// Loading state для async-данных (QA-SHARED-1: crash → fallback, не пустой экран).
// Пакет не таскает i18n: доступный лейбл приходит пропом (обязателен — это и
// видимый текст, и имя role=status).
export interface LoadingSpinnerProps {
  label: string;
  className?: string;
}

export function LoadingSpinner({ label, className }: LoadingSpinnerProps) {
  return (
    <div role="status" aria-live="polite" className={`flex items-center justify-center gap-2 p-6 text-text-secondary ${className ?? ""}`}>
      <span
        className="animate-spin rounded-full border-border border-t-primary"
        style={{
          width: "var(--ui-feedback-spinner-size)",
          height: "var(--ui-feedback-spinner-size)",
          borderWidth: "var(--ui-feedback-spinner-border-width)",
        }}
      />
      <span>{label}</span>
    </div>
  );
}
